<swoosh [text]="swooshText" [route]="swooshRoute" [fragment]="swooshFragment"></swoosh>

<div class="container">
  <div [hidden]="isApiDataLoaded" class="spinner-container relativeWithTopPadding">
    <div class="d-flex justify-content-center">
      <div class="spinner-border custom-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>

<div id="teaminsights-problem-solving" *ngIf="isApiDataLoaded">
  <div convertUrlsToRoutes [innerHTML]="reportContent"></div>
</div>
